'POMaint'.maint({panelStyle: "titled", icon: 'PeopleArrows'})
'Add Purchase Order'.title({when: 'adding'})
'Edit Purchase Order'.title({when: 'editing'})
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Save'.action({act: 'save'})
'View Receipts'.action({spec: 'ViewPOReceipts.js'})
'Download PDF'.action()
'Download CSV'.action()
'Add another'.action({act: 'add'})
'Attachments'.action({act: 'attachments'})
'PO'.datatype({caption: 'Purchase Order'})

'Order Summary'.panel()
'purchaseOrderNumber'.field({key: true})
'orderDate'.field({date: true})
'supplier'.field({refersTo: 'Supplier'})
'supplierFullAddress'.field({caption: 'Supplier Address', hidden: true})
'supplierReference'.field({caption: 'Supplier\'s Invoice#/Reference'})
'expectedDeliveryDate'.field({date: true})
'overdueDays'.field({numeric: true, hidden: true})
'stage'.field()
'includeTaxOption'.field({yesOrNo: true, hidden: true})
'pdfTitle'.field({hidden: true})
'pdfLogo'.field({image: true, hidden: true})
'businessName'.field({hidden: true})

'Delivery Details'.panel()
'deliverTo'.field()
'ourContactDetails'.field()
'location'.field({refersTo: 'Location', allowEmpty: false})
'carrier'.field()
'trackingNumber'.field()
'notesForSupplier'.field({multiLine: true})
'status'.field({refersTo: 'POStatus', readOnly: true, translateOnDisplay: true})
'receivedDate'.field({date: true, readOnly: true})
'dateOfLastReceiptFromThisSupplier'.field({date: true, readOnly: true})

'Amounts'.panel()
'supplierCurrency2'.field({hidden: true})
'currency'.field({refersTo: 'Currency'})
'exchangeRate'.field({numeric: true, minDecimals: 4})
'costIncTax'.field({numeric: true, decimals: 2, hidden: true, caption: "Order Total (Inc Tax)"})
'costExclTax'.field({numeric: true, decimals: 2, hidden: true, caption: "Order Total (Excl Tax)"})
'costIncTaxFX'.field({numeric: true, decimals: 2, readOnly: true, caption: "Order Total (Inc Tax)"})
'costIncTaxFXWithCurrency'.field({hidden: true, caption: "Order Total (Inc Tax)"})
'tax'.field({numeric: true, decimals: 2, hidden: true})
'taxFX'.field({numeric: true, decimals: 2, readOnly: true, caption: "Tax"})

'Payment'.panel()
'paymentStatus'.field()
'paymentDueDate'.field({date: true, allowEmpty: true})
'daysUntilPaymentDue'.field({numeric: true, readOnly: true})

'Lines'.manifest()
'Add Line'.action({act: 'add'})
'Auto Lines - Min-Max'.action()
'Bulk Add'.action()
'POLine'.datatype()
'thumbnailImage'.field()
'descriptionAndSKU'.field({showAsLink: true, readOnly: true})
'sku'.field({readOnly: true})
'supplierSku'.field({readOnly: true})
'quantityPU'.field({readOnly: false, caption: 'Purch Unit Qty'})
'uomDisplay'.field({readOnly: true, caption: 'UOM'})
'quantity'.field({readOnly: false})
'unitCostIncTaxFX'.field({readOnly: false})
'unitCostExclTaxFX'.field({readOnly: false})
'lineCostExclTaxFX'.field({readOnly: true})
'lineCostIncTaxFX'.field({readOnly: true})
'Edit'.action({place: 'row', act: 'edit'})
'Trash'.action({place: 'row', act: 'trash'})
'POLineMaint.js'.maintSpecname()

'paymentStatus'.options(['Unpaid', 'Prepayment Required', 'Paid'])

'paymentDueDate'.visibleWhen((maint, po) => {
  let res = po.paymentStatus && (po.paymentStatus !== 'Paid')
  return res
})

'daysUntilPaymentDue'.visibleWhen((maint, po) => {
  return po.paymentStatus && (po.paymentStatus !== 'Paid') && global.ymdIsSet(po.paymentDueDate)
})

'daysUntilPaymentDue'.calculate(po => {
  return - global.todayYMD().dateSubtract(po.paymentDueDate)
})

'Bulk Add'.act(async (maint, po) => {
  let supplier = await po.toSupplier()
  if ( ! supplier ) {
    maint.showMessage("Please select a Supplier first")
    return
  }
  await maint.segue('view', 'BulkAdd.js', po)
})

'quantity'.readOnlyWhen((maint, poLine) => {
  return poLine.purchasingUOMDiffers()
})

'quantityPU'.readOnlyWhen((maint, poLine) => {
  return ! poLine.purchasingUOMDiffers()
})

'quantityPU'.columnVisibleWhen(grid => {
  let c = 'Configuration'.bringSingleFast(); if ( ! c ) return false
  let res = c.showUOMOnPOLines === 'Yes'
  return res
})

'uomDisplay'.columnVisibleWhen(grid => {
  let c = 'Configuration'.bringSingleFast(); if ( ! c ) return false
  let res = c.showUOMOnPOLines === 'Yes'
  return res
})

'pdfTitle'.calculate(po => {
  return 'PURCHASE ORDER'.translate()
})

'pdfLogo'.calculate(async po => {
  let c = await 'Configuration'.bringFirst(); if ( ! c ) return null
  return c.poPdfLogoUrl
})

'businessName'.calculate(async po => {
  let c = await 'Configuration'.bringFirst(); if ( ! c ) return null
  return c.businessName
})

'PO'.method('refreshClumps', async function() {
  let lines = await this.toPOLines()
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    await line.refreshClumps()
  }
})

'PO'.method('toPOLines', async function() {
  return await 'POLine'.bringChildrenOf(this)
})

'receivedDate'.calculate(async po => {
  let rec = await po.toLastPOReceipt(); if ( ! rec ) return global.emptyYMD()
  return rec.receivedDate
})

'dateOfLastReceiptFromThisSupplier'.calculate(async po => {
  let supplier = await po.toSupplier(); if ( ! supplier ) return global.emptyYMD()
  let rec = await supplier.toLastPOReceipt(); if ( ! rec ) return global.emptyYMD()
  return rec.receivedDate
})

'receivedDate'.visibleWhen((maint, po) => {
  return po.receivedDate && (po.receivedDate !== global.emptyYMD())
})

'PO'.method('toLastPOReceipt', async function () {
  let recs = await 'POReceipt'.bring({purchaseOrder: this})
  if ( recs.length === 0 ) return null
  recs.sort((r1, r2) => r1.receivedDate > r2.receivedDate ? 1 : -1)
  return recs[recs.length - 1]
})

'PO'.afterCreating(async function () {
  let c = await 'Configuration'.bringFirst(); if ( ! c ) return
  this.includeTaxOption = c.enterPurchasePricesInclusiveOfTax
})

'lineCostExclTaxFX'.columnVisibleWhen((maint, po) => {
  return po.includeTaxOption === "No"
})

'lineCostIncTaxFX'.columnVisibleWhen((maint, po) => {
  return po.includeTaxOption !== "No"
})

'unitCostExclTaxFX'.columnVisibleWhen((maint, po) => {
  return po.includeTaxOption === "No"
})

'unitCostIncTaxFX'.columnVisibleWhen((maint, po) => {
  return po.includeTaxOption !== "No"
})

'View Receipts'.availableWhen(po => po && po.status !== "Awaiting Delivery")

'costIncTaxFXWithCurrency'.calculate(async po => {
  let currency = po.currency ? (po.currency.keyval + ' ') : ''
  let res = currency + global.numToStringWithXDecimals(po.costIncTaxFX, 2)
  return res
})

'supplier'.afterUserChange(async (oldInputValue, newInputValue, po) => {
  await po.refreshExpectedDeliveryDate()
  let s = await po.toSupplier()
  po.currency = (s && s.currency2) ? s.currency2 : null
  let c = await po.toCurrency()
  po.exchangeRate = c ? c.exchangeRate : 1
})

'supplierCurrency2'.calculate(async po => {
  let s = await po.toSupplier()
  return s ? s.currency2 : null
})

'currency'.visibleWhen((maint, po) => {
  return po.supplierCurrency2 ? true : false
})

'currency'.afterUserChange(async (oldInputValue, newInputValue, po) => {
  let c = await po.toCurrency()
  po.exchangeRate = c ? c.exchangeRate : 1
})

'exchangeRate'.inception(1)

'exchangeRate'.visibleWhen((maint, po) => {
  return po.currency ? true : false
})

'PO'.method('toCurrency', async function() {
  return await this.referee('currency')
})

'stage'.options(['Entered', 'Sent to Supplier', 'Confirmed', 'Goods In Transit', 'Goods Arrived', 'Complete'])

'POMaint'.warning(async (maint, po) => {
  let s = await po.toSupplier(); if ( ! s ) return
  let min = s.minimumOrderValue; if ( ! min ) return
  if ( po.costIncTaxFX >= min ) return
  return "Supplier minimum order value is".translate() + " " + global.numToStringWithXDecimals(min, 2) + 
    " (" + "this order's value is only".translate() + " " + global.numToStringWithXDecimals(po.costIncTaxFX, 2) + ")"
})

'PO'.method("hasLines", async function () {
  let lines = await 'POLine'.bringChildrenOf(this)
  return lines.length > 0
})

'location'.afterUserChange(async (oldInputValue, newInputValue, po) => {
  let hasLines = await po.hasLines()
  if ( hasLines )
    return "Location cannot be altered once purchase order lines have been added"
})

'orderDate'.afterUserChange(async (oldInputValue, newInputValue, po) => {
  await po.refreshExpectedDeliveryDate()
})

'PO'.method('toSupplier', async function() {
  return await this.referee('supplier')
})

'PO'.method('refreshExpectedDeliveryDate', async function() {
  let supplier = await this.referee('supplier'); if ( ! supplier ) return
  if ( ! this.orderDate ) return
  this.expectedDeliveryDate = this.orderDate.incDays(supplier.deliveryLeadDays)
})

'Auto Lines - Min-Max'.act(async (maint, po) => {

  let knt = 0
  let potentials = {}

  let getDefaultTaxPct = async () => {
    let config = await 'Configuration'.bringSingle(); if ( ! config ) return 0
    return config.taxPct
  }

  let addPotential = async (pot) => {
    let inv = await pot.avenue.referee('inventory'); if ( ! inv ) return
    let prodRef = inv.product; if ( ! prodRef ) return
    let prod = await inv.toProduct(); if ( ! prod ) return
    potentials[prodRef.id] = pot
  }

  let calcSales = async () => {
    let orderItems = await 'order_items.RecentOrActive'.bring()
    for ( var i = 0; i < orderItems.length; i++ ) {
      if ( (i % 100) === 0 )
        await global.updateProgress(0.3 + ((i / orderItems.length) * 0.3))
      let orderItem = orderItems[i]
      let status = orderItem.order_status
      if ( (status !== "wc-pending") && (status !== "wc-failed") && (status !== "wc-partially-paid") ) continue
      let varId = orderItem._variation_id
      let productId = varId ? varId : orderItem._product_id
      let pot = potentials[productId]; if ( ! pot ) continue
      if ( ! pot.onSalesOrders )
        pot.onSalesOrders = 0
      pot.onSalesOrders += orderItem._qty
    }
  }

  let convertToPU = (inv, qty) => {
    let ratio = inv.quantityPerPurchasingUOM; if ( ! ratio ) return qty
    return Math.ceil(qty / ratio)
  }

  let createAutoLines = async () => {
    await global.updateProgress(0.05)
    let avenues = await 'Avenue'.bring({supplier: po.supplier})
    let i
    for ( i = 0; i < avenues.length; i++ ) {
      let avenue = avenues[i]
      if ( avenue.isMain !== 'Yes' ) continue
      await addPotential({avenue: avenue})
    }
    await global.updateProgress(0.3)
    await calcSales()
    let currency = await po.toCurrency()
    await global.updateProgress(0.6)
    let len = Object.keys(potentials).length
    i = 0
    for ( var prodId in potentials ) {
      i++
      if ( (i % 100) === 0 )
        await global.updateProgress(0.6 + ((i / len) * 0.4))
      let pot = potentials[prodId]
      let inv = await pot.avenue.referee('inventory'); if ( ! inv ) continue
      if ( ! pot.onSalesOrders )
        pot.onSalesOrders = 0
      let avail = inv.quantityOnHand - pot.onSalesOrders + inv.quantityOnPurchaseOrders
      let surplus = avail - inv.minQuantity
      if ( surplus >= 0 ) continue
      let qty = - surplus
      if ( inv.maxQuantity > 0 )
        qty = inv.maxQuantity - avail
      if ( qty < 1 ) continue
      if ( qty < pot.avenue.minimumOrderQuantity )
        qty = pot.avenue.minimumOrderQuantity
      let poLine = await maint.addChildCast()
      poLine.product = inv.product
      poLine.description = inv.productName
      poLine.taxPct = await getDefaultTaxPct()
      let cost = await inv.getDefaultPurchaseUnitCostIncTax()
      if ( poLine.includeTaxOption === 'Yes' ) {
        poLine.unitCostIncTaxFX = await global.localAmountToForeign(cost, currency)
        poLine.unitCostIncTaxFX = global.roundTo2Decimals(poLine.unitCostIncTaxFX)
      } else {
        let costExclTax = cost / ( 1 + (poLine.taxPct / 100) )
        poLine.unitCostExclTaxFX = await global.localAmountToForeign(costExclTax, currency)
        poLine.unitCostExclTaxFX = global.roundTo2Decimals(poLine.unitCostExclTaxFX)
      }
      poLine.quantity = qty
      poLine.uom = global.copyObj(inv.purchasingUOM)
      await poLine.refreshCalculations({force: true, includeDefers: true})
      if ( poLine.purchasingUOMDiffers() ) {
        poLine.quantityPU = convertToPU(inv, poLine.quantity)
        await poLine.maybeRefreshQuantity()
      }
      knt++
    }
  }

  if ( ! po.supplier ) {
    maint.showMessage("Please select a Supplier before attempting to generate auto PO lines")
    return
  }
  global.startProgress({message: 'Generating automatic purchase order lines using Min-Max algorithm...'})
  try {
    await createAutoLines()
  } finally {
    global.stopProgress()
  }
  if ( knt === 0 ) {
    maint.showMessage("This supplier isn't the main supplier of any products with available quantity less than the low stock threshold")
    return
  }

})

'overdueDays'.calculate(async (po) => {
  return global.todayYMD().dateSubtract(po.expectedDeliveryDate)
})

'costIncTax'.calculate(async (po) => {
  let lines = await 'POLine'.bringChildrenOf(po)
  let res = 0
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    let lineCostIncTax = await line.calcLineCostIncTax()
    res += lineCostIncTax
  }
  return res
})

'costExclTax'.calculate(async (po) => {
  let lines = await 'POLine'.bringChildrenOf(po)
  let res = 0
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    let lineCostExclTax = await line.calcLineCostExclTax()
    res += lineCostExclTax
  }
  return res
})

'costIncTaxFX'.calculate(async (po) => {
  let lines = await 'POLine'.bringChildrenOf(po)
  let res = 0
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    let lineCostIncTax = await line.calcLineCostIncTaxFX()
    res += lineCostIncTax
  }
  return res
})

'tax'.calculate(async (po) => {
  let lines = await 'POLine'.bringChildrenOf(po)
  let res = 0
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    let lineTax = await line.getLineTaxUnrounded()
    res += lineTax
  }
  return res
})

'taxFX'.calculate(async (po) => {
  let lines = await 'POLine'.bringChildrenOf(po)
  let res = 0
  for ( var i = 0; i < lines.length; i++ ) {
    let line = lines[i]
    let lineTax = await line.getLineTaxFXUnrounded()
    res += lineTax
  }
  return res
})

'supplierFullAddress'.calculate(async (po) => {
  let supplierRef = po.supplier; if ( ! supplierRef ) return null
  let id = supplierRef.id; if ( ! id ) return null
  let supplier = await 'Supplier'.bringSingle({id: supplierRef.id}); if ( ! supplier ) return null
  return supplier.getFullAddress()
})

'POMaint'.whenAdding(async function() {

  let defaultNumber = async () => {
    let nextNo = await 'NextNumber'.bringOrCreate({forDatatype: 'PO'})
    nextNo.number = nextNo.number + 1
    let noStr = nextNo.number + ""
    let adjNo = "PO" + noStr.padStart(5, '0')
    //'purchaseOrderNumber'.set(adjNo)
    this.setFieldValue('purchaseOrderNumber', adjNo)
  }

  let defaultDeliverTo = async () => {
    let c = await 'Configuration'.bringSingle(); if ( ! c ) return
    let addr = await c.getFullDeliveryAddress()
    //'deliverTo'.set(addr)
    this.setFieldValue('deliverTo', addr)
  }

  let defaultContact = async () => {
    let c = await 'Configuration'.bringSingle(); if ( ! c ) return
    let res = c.phoneNumber
    if ( c.email ) {
      if ( res )
        res = res + ", "
      res = res + c.email
    }
    //'ourContactDetails'.set(res)
    this.setFieldValue('ourContactDetails', res)
  }

  await defaultNumber()
  await defaultDeliverTo()
  await defaultContact()

})

'status'.inception('Awaiting Delivery')

'location'.inception(async po => {
  let loc = await 'Location'.bringSingle({locationName: 'General'})
  return loc.reference()
})

'PO'.method('refreshStatus',
  async function() {
    let lines = await 'POLine'.bringChildrenOf(this)
    lines = lines.filter(line => (! line.lineType) || (line.lineType === "Product") || (line.quantity > 0) )
    if ( lines.length === 0 ) {
      this.status = 'Awaiting Delivery'
    } else if ( lines.all(line => (Math.abs(line.quantity) > 0) && Math.abs(line.receivedQuantity + line.cancelledQuantity) >= Math.abs(line.quantity)) ) {
      this.status = 'Received'
    } else if ( lines.none(line => line.receivedQuantity !== 0) ) {
      this.status = 'Awaiting Delivery'
    } else if ( lines.some(line => Math.abs(line.receivedQuantity + line.cancelledQuantity) < Math.abs(line.quantity)) ) {
      this.status = 'Partially Received'
    } else {
      this.status = 'Received'
    }
    await this.refreshClumps()
  }
)

'PO'.method('toDateLastItemReceived', async function() {
  let receipts = await 'POReceipt'.bringChildrenOf(this)
  let latestDate
  for ( var i = 0; i < receipts.length; i++ ) {
    let receipt = receipts[i]
    let receivedDate = receipt.receivedDate
    if ( (! latestDate) || (receivedDate > latestDate) )
      latestDate = receivedDate
  }
  return latestDate
})

'PO'.beforeSaving(async function() {
  if ( (this.status !== 'Awaiting Delivery') && this.location && this.old && this.old.location && this.propChanged('location') ) {
    throw(new Error("You cannot change the location on an order that has been received or partially received".translate()))
  }
})

'Download PDF'.act(async (maint, po) => {
  maint.downloadPDF({spec: "POPdf.js", docName: po.purchaseOrderNumber + ".PDF"})
})

'Download CSV'.act(async (maint, po) => {
  maint.downloadCSV({spec: "POCsv.js", docName: po.purchaseOrderNumber + ".CSV"})
})

'POMaint'.makeDestinationFor('PO')

'descriptionAndSKU'.destination(async poLine => {
  if ( poLine.lineType === 'Product' )
    return await poLine.toProduct()
  return poLine
})

'PO'.method('toLocation', async function() {
  let res = await this.referee('location')
  return res
})

'PO'.method('toLocationName', async function() {
  let loc = await this.toLocation(); if ( ! loc ) return 'General'
  let res = loc.locationName
  if ( ! res )
    res = 'General'
  return res
})

